<template>
  <div v-if="productData.productId" :class="rootCss" :style="showCard ? 'display:block' : 'display:none'">
    <div class="row no-gutters justify-content-between">
      <span class="closeQuickModal" v-on:click="closeModal" v-show="modal">
        <i class="lni lni-close"></i>
      </span>
      <div class="quick-v-prod-name" v-show="showName">
        {{productData.productName}}
      </div>

      <div v-show="showImage" class="col-12 col-md-5 quick-v-thumb">
        <div class="thumbnail_container">
          <div class="thumbnail">
            <picture>
              <source media="(max-width: 270px)" :srcset="mainImage.medium">
              <img :src="mainImage.large"
                   :alt="productData.productName">
            </picture>
          </div>
        </div>
      </div>

      <AdvCartProductCustomizationEditor
        ref="customizationEditor"
        :class="{
          'col-12': true,
          'col-md-6': this.modal
        }"
        v-if="null !== getCustomizationSchema"
        :schema="getCustomizationSchema"
      />

      <div
        :class="{
          'col-12': showImage,
          'col-md-7': showImage && null === getCustomizationSchema,
        }"
        class="quick-v-info"
      >
        <div class="row no-gutters">
          <div class="col-12 productDescription"
               v-show="showContent"
               v-html="productData.productDescription"
               ss-container>
          </div>
          <div class="col-6 quick-v-code" v-show="showContent">
            <span class="quick-v-code-ttl">{{ t('product_code.short') }}:</span>
            <span class="quick-v-code-id">{{productData.productId}}</span>
          </div>
          <div class="col-6 quick-v-code quick-v-barcode" v-show="showContent && productData.barCodes.length">
            <span class="quick-v-code-ttl">{{ t('product_barcode') }}:</span>
            <span class="quick-v-code-id">{{productData.barCodes[0]}}</span>
          </div>
          <div class="col-12 quick-v-price-row" v-show="showContent">
            <div class="row">
              <span v-show="hasDiscount || hasDiscountNoPriceTracking" class="col-6 quick-v-og-price">
                <span class="quick-v-save-ttl">{{ t('product.price.reference') }}</span>
                <span v-if="hasDiscount" v-html="priceWithSign(productData.priceTracking.referencePrice, getSign())"></span>
                <span v-if="hasDiscountNoPriceTracking" v-html="priceWithSign(productData.productOldPrice, getSign())"></span>
              </span>
              <!--<span v-show="hasDiscount || hasDiscountNoPriceTracking" class="col-5 col-sm-5 quick-v-save">
                <span class="quick-v-save-ttl">{{ t('you_earn') }}</span>
                <span v-if="hasDiscount" class="quick-v-save-amount" v-html="priceWithSign(productData.priceTracking.saveValue, getSign())"></span>
                <span v-if="hasDiscountNoPriceTracking" class="quick-v-save-amount" v-html="priceWithSign(diffStringPrices(productData.productOldPrice, productData.productFinalPrice), getSign())"></span>
              </span>-->

              <span class="col-6 quick-v-price" v-html="priceWithSign(productData.productFinalPrice, getSign())">
              </span>
            </div>
          </div>

          <!-- Attributes -->
          <attribute-select
            v-if="hasAttributes"
            v-on:matched-product-code="codeIdChanged"
            v-on:product-attribute-selected="attributeSelected"
            :product-id="productId"></attribute-select>

          <variation-select
            v-if="hasVariationEntries && variationsActive"
            :product-id="productId">
          </variation-select>

          <div class="col-12 quick-v-quantity quick-v-unavailable"
               v-if="productCodeId && (inactiveProduct || unavailableProduct)">
            <span v-show="inactiveProduct && config.showInactiveProductCodes">
              {{ t('product_status.unavailable') }}
            </span>
            <span v-show="unavailableProduct && !inactiveProduct">
              {{ t('product_status.unavailable.out_of_stock') }}
            </span>
          </div>
          <!-- Qty-->
          <div
            class="col-6 quick-v-quantity"
            v-else>
            <adv-product-input-spinner
              :product-code-id="productCodeId"
              :watch-for-product-code-id-changes="false"
              :max-amount="maxAmountForInputSpinner"
              v-bind:quantity="quantity"
              v-on:quantity-changed="quantityChanged"></adv-product-input-spinner>
          </div>
          <!-- Btn-->
          <div class="col-6 quick-v-tocart">
            <adv-cart-button
              class="addToCart"
              :unavailable="unavailableProduct || cartLimitForProductReached"
              :cart-limit-reached="cartLimitForProductReached"
              :has-attributes="hasAttributes"
              :selected-attribute-id="selectedAttributeId"
              v-on:btn-click="addToCard"
              :stock="productCodeData.productStock"
              :progress="progress"
              :productId="this.productId"
              v-bind:quantity="quantity"></adv-cart-button>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { cloneDeep, get, isEmpty, some } from 'lodash-es'
import store from '../../vue/store'
import productMixin from './mixins/productMixins'
import AttributeSelect from './attributes/AttributeSelect'
import AdvCartButton from './AdvCartButton'
import AdvProductInputSpinner from './AdvProductInputSpinner'
import VariationSelect from './variations/VariationSelect'
import { mapActions, mapGetters } from 'vuex'
import AdvCartProductCustomizationEditor from './cartProductCustomizations/AdvCartProductCustomizationEditor.vue'

export default {
  name: 'AdvProductCard',
  components: {
    AttributeSelect,
    VariationSelect,
    AdvCartButton,
    AdvProductInputSpinner,
    AdvCartProductCustomizationEditor
  },
  props: {
    productId: {
      type: Number
    },
    showName: {
      type: Boolean,
      default: false
    },
    showContent: {
      type: Boolean,
      default: false
    },
    showImage: {
      type: Boolean,
      default: false
    },
    modal: {
      type: Boolean,
      default: false
    },
    recommendationType: {
      type: String,
      default: null
    },
    recommendationId: {
      type: String,
      default: null
    }
  },
  mixins: [productMixin],
  data () {
    return {
      version: '0.0.2',
      productCodeId: null,
      quantity: 1,
      showCard: true,
      progress: false,
      mainImage: {
        is_main: '1',
        original: store.state.noImage,
        small: store.state.noImage,
        medium: store.state.noImage,
        large: store.state.noImage
      }
    }
  },
  mounted () {
    this.setProductCodeIdForOneOnOne()
    this.setMainImage()
  },
  watch: {
    productId () {
      this.setProductCodeIdForOneOnOne()
      this.setMainImage()
    }
  },
  computed: {
    ...mapGetters([
      'getUniqueProductVariationValueIds',
      'cartProductWithCustomizationQuantity',
      'cartProductCodeQuantity',
      'getSelectedCurrency'
    ]),
    ...mapGetters('cartProductCustomizations', ['getSchemaById']),
    ...mapGetters('productChart', ['getProductChartSettings']),
    rootCss () {
      if (this.modal) {
        return 'modalQuickV'
      }
      return ''
    },
    config () {
      return store.getters.config
    },
    hasAttributes () {
      return some(this.productData.productCodes, (e) => {
        return e.productCodeAttributes.length > 0
      })
    },
    getCustomizationSchema () {
      if (!('customizationSchemaId' in this.productData) || null === this.productData.customizationSchemaId) {
        return null
      }
      if (('customizationSchemaRange' in this.productData) && this.productData.customizationSchemaRange !== null) {
        const from = this.productData.customizationSchemaRange.from
        const to = this.productData.customizationSchemaRange.to
        if (from !== null && new Date(from) > new Date()) {
          return null
        }
        if (to !== null && new Date(to) < new Date()) {
          return null
        }
      }
      const schema = this.getSchemaById(this.productData.customizationSchemaId)
      if (null === schema || !('schema' in schema) || ('is_active' in schema && false === schema.is_active)) {
        return null
      }
      return cloneDeep(schema)
    },
    hasVariationEntries () {
      return this.getUniqueProductVariationValueIds.length > 0
    },
    productPriceClass () {
      return 'col-xs-12 ' + (this.productData.productFinalPrice === this.productData.productOldPrice ? '' : 'col-sm-4 ') + 'text-right productItemMainPrice'
    },
    listImage () {
      return this.productData ? this.productData.productImage.list : store.getters.noImage
    },
    inactiveProduct () {
      return !this.productCodeData.productActive
    },
    unavailableProduct () {
      return this.productCodeData.productStock <= 0 || this.productData.productFinalPrice <= 0 || this.isProductInAvailabilityDate
    },
    isProductInAvailabilityDate () {
      const { availableFrom, availableUntil } = this.productData
      const currentDate = Date.now()
      return (
        (availableFrom != null && currentDate < new Date(availableFrom).getTime()) ||
        (availableUntil != null && currentDate > new Date(availableUntil).getTime())
      )
    },
    cartLimitForProductReached () {
      return this.productCodeData.productStock === this.cartQuantity
    },
    selectedAttributeId () {
      return parseFloat(store.getters.getSelectedAttributeId)
    },
    cartQuantity () {
      if (
        null !== this.getCustomizationSchema &&
        !isEmpty(get(this, ['$refs', 'customizationEditor', 'getSchema']))
      ) {
        return this.cartProductWithCustomizationQuantity(
          this.productCodeId,
          this.$refs.customizationEditor.getSchema,
          0
        )
      }
      return this.cartProductCodeQuantity(this.productCodeId, 0)
    },
    maxAmountForInputSpinner () {
      return this.productCodeData.productStock - this.cartQuantity
    },
    variationsActive () {
      return store.getters.getVariationsActive
    },
    productChartSettings () {
      return this.getProductChartSettings
    },
    hasDiscount () {
      return this.productChartSettings?.enabled &&
        this.productData.priceTracking?.shouldDisplay &&
        this.productData.priceTracking?.discountPass
    },
    hasDiscountNoPriceTracking () {
      return !this.productChartSettings?.enabled && this.productData.productHasDiscount
    }
  },
  methods: {
    ...mapActions(['addToCartClicked', 'setSelectedProductCodeId', 'setSelectedAttributeId']),
    setProductCodeIdForOneOnOne () {
      if (!this.hasAttributes) {
        this.codeIdChanged(this.productData.productCodes[0].productCodeId)
        return
      }

      this.quantity = 1
    },
    closeModal () {
      this.showCard = false
      this.$emit('close-quick-view')
      this.clearSelectedAttributeId()
    },
    clearSelectedAttributeId () {
      if (this.hasAttributes) {
        this.setSelectedAttributeId(null)
      }
    },
    priceWithSign (priceString, priceSign) {
      return (parseFloat(priceString) * this.getSelectedCurrency.rate).toFixed(2) + priceSign
    },
    getSign () {
      return this.getSelectedCurrency.symbol
    },
    diffStringPrices (priceA, priceB) {
      return (parseFloat(priceA) - parseFloat(priceB)).toFixed(2).toString()
    },
    attributeSelected (attributeId) {
      this.setSelectedAttributeId(attributeId)
    },
    codeIdChanged (productCodeId) {
      this.productCodeId = productCodeId
      if (this.productCodeId) {
        this.setSelectedProductCodeId(this.productCodeId)
        this.setMainImage()
      }
    },
    quantityChanged (quantity) {
      this.quantity = quantity
    },
    addToCard () {
      if ('customizationEditor' in this.$refs && !this.$refs.customizationEditor.validate()) {
        return
      }
      this.progress = true
      const cartPayload = {
        productCodeId: this.productCodeId,
        quantity: this.cartQuantity + this.quantity,
        recommendationId: this.recommendationId,
        recommendationType: this.recommendationType
      }
      if (this.getCustomizationSchema !== null) {
        cartPayload.quantity = this.quantity
        cartPayload.cartProductCustomizations = this.$refs.customizationEditor.getSchema
      }
      this.addToCartClicked(cartPayload).then(() => {
        this.progress = false
        this.quantity = 1
      })
    },
    setMainImage () {
      if (this.productCodeId) {
        this.mainImage = this.productData.images[this.productCodeId].find(image => image.is_main === '1')
      } else {
        this.mainImage = this.productData.images[parseInt(Object.keys(this.productData.images)[0])].find(image => image.is_main === '1')
      }
    }
  }
}
</script>
